import { zodResolver } from '@hookform/resolvers/zod';
import { changePasswordSchema, type ChangePasswordInput } from '@bifeai/shared';
import { Button, Callout, Field, Input } from '@bifeai/ui';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { api, applyFieldErrors, errorMessage } from '../lib/api';

export function ChangePasswordForm({
  currentLabel = 'Contraseña actual',
  submitLabel = 'Cambiar contraseña',
  onDone,
}: {
  currentLabel?: string;
  submitLabel?: string;
  onDone: () => void | Promise<void>;
}) {
  const [formError, setFormError] = useState<string | null>(null);
  const {
    register,
    handleSubmit,
    setError,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<ChangePasswordInput>({
    resolver: zodResolver(changePasswordSchema),
  });

  const onSubmit = handleSubmit(async (values) => {
    setFormError(null);
    try {
      await api.post('/auth/change-password', values);
      reset();
      await onDone();
    } catch (err) {
      if (!applyFieldErrors(err, setError)) setFormError(errorMessage(err));
    }
  });

  return (
    <form className="bf-form" onSubmit={onSubmit} noValidate>
      {formError && <Callout tone="danger">{formError}</Callout>}
      <Field label={currentLabel} error={errors.currentPassword?.message}>
        <Input type="password" autoComplete="current-password" {...register('currentPassword')} />
      </Field>
      <Field label="Nueva contraseña" hint="Al menos 10 caracteres, con letras y números." error={errors.newPassword?.message}>
        <Input type="password" autoComplete="new-password" {...register('newPassword')} />
      </Field>
      <Button type="submit" variant="primary" loading={isSubmitting}>
        {submitLabel}
      </Button>
    </form>
  );
}
